// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sDNNp","select":"styles_select__1u9wG"};